import { render, staticRenderFns } from "./JoinSnkrhudCommunity.vue?vue&type=template&id=2d990eaf&"
import script from "./JoinSnkrhudCommunity.vue?vue&type=script&lang=js&"
export * from "./JoinSnkrhudCommunity.vue?vue&type=script&lang=js&"
import style0 from "./JoinSnkrhudCommunity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports